import { coreFetch } from '@libs/core';

/**
 * @deprecated since `libs/core/src/utils/apiFetch.ts` is created to allow passing backend errors to the UI instead of null
 */
export const typedFetch = coreFetch;
